// src/firebase.js
// Analytics helpers — single point for the entire app (Google tag, loaded after consent).
// Import { analytics, logEvent } from './firebase' wherever you need to track events.

// Analytics is now the single Google tag G-2PSSF05G5T, loaded only after the
// visitor taps Accept (see components/CookieNotice.jsx). Nothing is sent before that.
export const analytics = null;

const sendEvent = (name, params) => {
  try {
    if (typeof window !== 'undefined' && window.__imfuyoGaLoaded && typeof window.gtag === 'function') {
      window.gtag('event', name, params || {});
    }
  } catch (e) { /* analytics must never break the site */ }
};
const logEvent = (_unused, name, params) => sendEvent(name, params);
const setUserProperties = (_unused, props) => {
  try {
    if (typeof window !== 'undefined' && window.__imfuyoGaLoaded && typeof window.gtag === 'function') {
      window.gtag('set', 'user_properties', props || {});
    }
  } catch (e) { /* ignore */ }
};

// ─────────────────────────────────────────────
// Helper: track a page/screen view
// Call this every time the user navigates to a new page.
// ─────────────────────────────────────────────
export const trackPageView = () => { /* page views are sent automatically by the Google tag */ };

// ─────────────────────────────────────────────
// Helper: track a button / CTA click
// ─────────────────────────────────────────────
export const trackButtonClick = (buttonName, extraParams = {}) => {
  logEvent(analytics, "select_content", {
    content_type: "button",
    item_id: buttonName,
    ...extraParams,
  });
};

// ─────────────────────────────────────────────
// Helper: track WhatsApp button click
// ─────────────────────────────────────────────
export const trackWhatsAppClick = () => {
  logEvent(analytics, "contact", {
    method: "whatsapp",
  });
};

// ─────────────────────────────────────────────
// Helper: track shop / marketplace interactions
// ─────────────────────────────────────────────
export const trackShopView = (itemName, itemCategory) => {
  logEvent(analytics, "view_item", {
    item_name: itemName,
    item_category: itemCategory,
  });
};

// ─────────────────────────────────────────────
// Helper: track membership / sign-up intent
// ─────────────────────────────────────────────
export const trackMembershipIntent = () => {
  logEvent(analytics, "sign_up", {
    method: "imfuyo_membership",
  });
};

// ─────────────────────────────────────────────
// Helper: track Mbuzi Plus Training interest
// ─────────────────────────────────────────────
export const trackMbuziPlusInterest = (action = "view") => {
  logEvent(analytics, "select_promotion", {
    promotion_name: "mbuzi_plus_training",
    creative_slot: action,
  });
};

// ─────────────────────────────────────────────
// Helper: set custom user properties (call once per session)
// e.g. trackUserProperties({ user_type: 'farmer', region: 'Kenya' })
// ─────────────────────────────────────────────
export const trackUserProperties = (properties = {}) => {
  setUserProperties(analytics, properties);
};

export default analytics;